import { render, staticRenderFns } from "./KundeHilfe.vue?vue&type=template&id=78737e4b&scoped=true&"
import script from "./KundeHilfe.vue?vue&type=script&lang=js&"
export * from "./KundeHilfe.vue?vue&type=script&lang=js&"
import style0 from "./KundeHilfe.vue?vue&type=style&index=0&id=78737e4b&scoped=true&lang=css&"
import style1 from "./KundeHilfe.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78737e4b",
  null
  
)

export default component.exports